import React, { useState, useEffect } from "react";
import Cookie from "js-cookie";
import { Link, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import styles from "./Header.module.scss";
import { EngenLogo, SearchIcon, BackButton, Navigation, CookieNotification } from "../index";
import useXBreakpoint from "../../hooks/useXBreakpoint";

const Header = ({ backButton, setCookieAcc }) => {
  const [showNavigation, setShowNavigation] = useState(false);
  const [isCookieAccepted, setIsCookieAccepted] = useState(true);

  const isMobile = useXBreakpoint(769);

  const history = useHistory();

  const handleToggleNavigation = () => () => setShowNavigation(!showNavigation);

  if (showNavigation) {
    document.body.style.overflow = "auto";
  } else {
    document.body.style.overflow = "unset";
  }

  const isCookieAccept = Cookie.get("cookie-accept");

  useEffect(() => {
    if (isCookieAccept) {
      setIsCookieAccepted(true);
      setCookieAcc(true);
    } else {
      setIsCookieAccepted(false);
      setCookieAcc(false);
    }
    //eslint-disable-next-line
  }, [isCookieAccept]);

  const handleAcceptCookie = () => {
    setIsCookieAccepted(true);
    setCookieAcc(true);
  };

  const handleLogoClick = () => () => {
    history.push("/");
    window.scrollTo(0, 0);
    setShowNavigation(false);
  };

  return (
    <>
      <CookieNotification onAccept={handleAcceptCookie} />
      <header className={`${styles.wrapper} ${!isCookieAccepted ? styles["cookie-accepted"] : ""}`}>
        <div className={styles.left}>
          <div onClick={handleLogoClick()}>
            <div className={styles["logo-block"]}>
              <EngenLogo />
            </div>
          </div>
          {backButton && <BackButton isCookieAccepted={isCookieAccepted} />}
        </div>

        {!isMobile && <div className={styles["search-block"]}></div>}

        <div className={styles.right}>
          <div className={styles["action-block"]}>
            <div className={styles.linkActionBlock}></div>
            <Link to="/search" className={styles["action-item"]}>
              <div className={styles["search-icon"]}>
                <SearchIcon />
              </div>
            </Link>
            <div className={styles["action-item"]} onClick={handleToggleNavigation()}>
              {!showNavigation ? (
                <div className={styles.burger} />
              ) : (
                <div className={styles.close}>&#10005;</div>
              )}
            </div>
          </div>
        </div>
      </header>

      {isMobile && (
        <div
          className={`${styles["search-block-mobile"]} 
          ${backButton ? styles.backButton : ""}`}></div>
      )}

      <CSSTransition
        in={showNavigation}
        timeout={300}
        classNames="navigation"
        mountOnEnter
        unmountOnExit>
        <Navigation />
      </CSSTransition>
    </>
  );
};

export default Header;
